interface AiConfigModalProps {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  maxWidth?: 'md' | 'lg' | 'xl';
}

export function AiConfigModal({ title, onClose, children, maxWidth = 'md' }: AiConfigModalProps) {
  const widthClass =
    maxWidth === 'xl' ? 'max-w-4xl' : maxWidth === 'lg' ? 'max-w-2xl' : 'max-w-md';
  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
      onClick={onClose}
      role="presentation"
    >
      <div
        className={`bg-white p-6 rounded-lg w-full space-y-3 max-h-[90vh] overflow-y-auto ${widthClass}`}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <h3 className="font-semibold">{title}</h3>
        {children}
      </div>
    </div>
  );
}
